import { useEffect, useState } from 'react';
import useAutomationFormDataQuery, { FilterField } from './useAutomationFormDataQuery';

export const useRequiredFilterFields = (selectedTriggerType: string) => {
    const { data, status } = useAutomationFormDataQuery({ onSuccess: () => {} });
    const [filteredFields, setFilteredFields] = useState<Array<FilterField>>([]);

    useEffect(() => {
        if (status === 'success' && data?.FILTER_FIELDS) {
            const filtered = data.FILTER_FIELDS.filter(field =>
                field.required || field.requiredOnTriggerType === selectedTriggerType
            );
            setFilteredFields(filtered);
        } else {
            setFilteredFields([]);
        }
    }, [data, status, selectedTriggerType]);

    return filteredFields;
};